import { Navigate, Route, Routes } from 'react-router';
import { EditEmployer } from './pages/edit-employer';
import { RegisterEmployer } from './pages/register-employer';
import { EmployerManagement } from '.';

export const EmployerRoutes = () => (
  <Routes>
    <Route index element={<EmployerManagement />} />
    <Route path="/registrar/:companyId" element={<RegisterEmployer />} />
    <Route path="/editar/:id" element={<EditEmployer />} />
    <Route
      path="*"
      element={<Navigate to="/gestao-de-colaboradores" replace />}
    />
  </Routes>
);
